function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
(function ($) {
  window.DGS.CenterSpotConfig = {
    mapBrowserWidth: false
  };
  window.DGS.OnLoad.getInstance().register(function () {
    var getClinicBrand = function getClinicBrand() {
      var lang = document.documentElement.lang;
      switch (lang) {
        case 'nl-nl':
          return 'Van Boxtel hoorwinkels';
        case 'en-gb':
          return 'Hidden Hearing';
        case 'en-ie':
          return 'Hidden Hearing';
        case 'en-us':
          return 'HearingLife';
        case 'en-ca':
          return 'HearingLife';
        case 'pt-pt':
          return 'Acustica Medica';
        case 'pl-pl':
          return 'Słuchmed';
        default:
          return 'Audika';
      }
    };
    var $thisSpot = $('.centre-spot');
    if ($thisSpot.length) {
      $thisSpot.each(function () {
        var host = window.location.host;
        // document.title = document.getElementById('centre-map').getAttribute('data-name');

        function initMap() {
          if (window.DGS.CenterSpotConfig.mapBrowserWidth) $('#centre-map').width($('body').width());
          var latLangArray;
          var myLatLng;
          var latLang = $('.centre-cta.button', $thisSpot).attr('id');
          if (latLang.length > 0) {
            latLangArray = latLang.split(',');
            myLatLng = {
              lat: parseFloat(latLangArray[0]),
              lng: parseFloat(latLangArray[1])
            };
          } else {
            myLatLng = {
              lat: 0,
              lng: 0
            };
          }
          var map = new google.maps.Map(document.getElementById('centre-map'), {
            zoom: parseInt(document.getElementById('centre-map').getAttribute('data-zoom')),
            center: myLatLng,
            disableDefaultUI: true,
            zoomControl: false,
            scaleControl: false,
            draggable: false,
            scrollwheel: false,
            disableDoubleClickZoom: true
          });
          $thisSpot.data('configuration');
          var marker = new google.maps.Marker({
            position: myLatLng,
            map: map,
            icon: document.getElementById('centre-map').getAttribute('data-icon')
          });
          if ($($thisSpot).hasClass('clinic-opening-hours-from-google')) {
            var brandName = getClinicBrand();
            var clinicName = document.querySelector('.address-title').innerText;
            var clinicAddress = document.querySelector('[itemprop=streetAddress]').innerText;
            var postalCode = document.querySelector('[itemprop=postalCode]').innerText;
            var locality = document.querySelector('[itemprop=addressLocality]').innerText;
            var service = new google.maps.places.PlacesService(map);
            var placeIdRequest = {
              query: "".concat(brandName, " ").concat(clinicName, " ").concat(clinicAddress, " ").concat(postalCode, " ").concat(locality),
              fields: ['place_id', 'types']
            };
            service.findPlaceFromQuery(placeIdRequest, function (results, placeIdStatus) {
              var placeId = results[0].place_id;
              var isHealthType = results[0].types.includes('health');
              if (placeIdStatus === google.maps.places.PlacesServiceStatus.OK && typeof placeId !== 'undefined' && isHealthType) {
                var openingHoursRequest = {
                  placeId: results[0].place_id,
                  fields: ['opening_hours']
                };
                service.getDetails(openingHoursRequest, function (result, openingHoursStatus) {
                  if (openingHoursStatus === google.maps.places.PlacesServiceStatus.OK && typeof result.opening_hours !== 'undefined') {
                    var hoursList = document.querySelector('.hours-list table tbody');
                    hoursList.innerHTML = '';
                    var googleOpeningHours = result.opening_hours.weekday_text;
                    googleOpeningHours.forEach(function (el) {
                      var row = document.createElement('tr');
                      var cell = document.createElement('td');
                      var cellText = document.createTextNode(el);
                      cell.appendChild(cellText);
                      row.appendChild(cell);
                      hoursList.appendChild(row);
                    });
                  }
                });
              }
            });
          }
        }
        $('.centre-cta.button', $thisSpot).on('click', function (e) {
          e.preventDefault();
          window.open("https://maps.google.com?daddr=".concat($(this).attr('id')), '_blank', 'toolbar=no, scrollbars=no, resizable=yes, top=0, left=0, width=900,height=650');
        });
        window.DGS.Resizer.getInstance().register(function () {
          if ((typeof google === "undefined" ? "undefined" : _typeof(google)) === 'object' && _typeof(google.maps) === 'object') {
            initMap();
          }
        });
      });
    }
  });
})(jQuery);